<template>
  <div style="padding-bottom:30px">
    <div class='content-header'>
      <div class='left'>
        <RadioGroup v-model="data.type">
          <Radio :label="0" :disabled="data.id?true:false">
            <span>云知印</span>
          </Radio>
          <Radio :label="1" :disabled="data.id?true:false">
            <span>智能运维</span>
          </Radio>
        </RadioGroup>
      </div>
      <div class='right'>

      </div>
      <div class='bottom'>

      </div>
    </div>
    <div>
      <!-- 云知印 -->
      <div v-show="data.type === 0">
        <type0 ref="type0" v-model="data" :agent="agent" @valid="setValid" @agent-change="agentSelect"></type0>
      </div>
      <!-- 抄表 -->
      <div v-show="data.type === 1">
        <type1 ref="type1" v-model="data" :agent="agent" @valid="setValid" @agent-change="agentSelect"></type1>
      </div>
      </br>

      <div style="float:right" v-if="is_compont">
        <Button type="text" @click="cancel">取消</Button>
        <Button type="primary" :loading="loading" @click="submit">确定</Button>
      </div>
      <Button v-else type="success" @click="submit" style="margin-left: 100px" :loading="loading" >保存</Button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import type0 from './type0';
import type1 from './type1';
export default {
  components: { type0,type1 },
  props:{
    is_compont:Boolean,
  },
  data() {
    return {
      agent: [],
      data: {
        type: 0,
        company_name: "",
        tel: "",
        company_tel: "",
        email: "",
        pay_type: 0,
        quota_date: 1,
        agent_id: null,
        al: [],
        note: "",
        contacts: ""
      },
      loading: false,
    };
  },
  mounted() {
    this.getAgentList({ p: 0, l: 1000, is_del: 0 }).then(res => {
      this.agent = res.data;
    });
    console.log(this.$route.params,'this.$route.params')
    if (this.$route.params.c_id || this.c_id) {
      this.infoCompany({ id: this.$route.params.c_id  }).then(res => {
        if (res.length) {
          this.data = res[0];
          this.data.al = [this.data.province, this.data.city, this.data.area];
        } else {
          this.$Message.error("未找到相应学校");
        }
      });
    }else {
      this.data.agent_id = this.user.id;
      this.getCompanyTel();
    }
  },
  methods: {
    cancel(){
      this.$emit("cancel",0);
    },
    agentSelect(e){
      this.data.agent_id = e;
      this.getCompanyTel();
    },
    getCompanyTel(){
      this.CompanyUserName({agent_id:this.data.agent_id}).then(res=>{
          this.data.tel = res;
      })
    },
    setValid(valid){
      try {
        if(valid){
          let user_company = {
            name: this.data.company_name,
            tel: this.data.company_tel,
            email: this.data.email,
            agent_id: this.data.agent_id,
            note: this.data.note,
            type: this.data.type,
            contacts: this.data.contacts,
            address:this.data.address
          };
          if (!this.data.type) {
            user_company.pay_type = this.data.pay_type;
            user_company.quota_date = this.data.quota_date;
          }
          if (this.data.al.length > 0) {
            user_company.province = this.data.al[0] || "";
            user_company.city = this.data.al[1] || "";
            user_company.area = this.data.al[2] || "";
          }
          if (this.data.id) {
            user_company.id = this.data.id;
            this.updateCompany({
              user: { id: this.data.user_id, tel: this.data.tel },
              user_company: user_company
            }).then(res => {
              this.loading = false;
              if(res){
                this.$Message.success("保存成功");
              }else{
                this.$Message.error("保存失败,名称已存在")
              }
            });
          } else {
            let user = {
              name: this.data.company_name,
              is_company: 1
            };
            // if (!this.data.type) {
              (user.tel = this.data.tel), (user.password = "123456");
            // }
            this.insertCompany({ user: user, user_company: user_company }).then(
              res => {
                if (res.status) {
                  if (this.is_compont) {
                    this.$emit("on-change",res.company_id);
                  }
                  this.data.id = res.company_id;
                  this.data.user_id = res.user_id;
                  this.data.agent_id = res.agent_id;
                  this.loading = false;
                } else {
                  this.loading = false;
                  this.$Message.error(res.log);
                }
              }
            );
          }
          console.log("运行")
        }else{
          this.loading = false;
        }
      } catch (error) {
        console.log(error)
      }
    },
    submit() {
      this.loading = true;
      this.$refs[`type${this.data.type}`].formValidate()

      // this.$refs.formInline.validate(valid => {
      //   if (valid) {

          // this.loading = true;
          // let user_company = {
          //   name: this.data.company_name,
          //   tel: this.data.company_tel,
          //   email: this.data.email,
          //   // pay_type: this.data.pay_type,
          //   // quota_date: this.data.quota_date,
          //   agent_id: this.data.agent_id,
          //   note: this.data.note,
          //   type: this.data.type
          // };
          // if (!this.data.type) {
          //   user_company.pay_type = this.data.pay_type;
          //   user_company.quota_date = this.data.quota_date;
          // }
          // if (this.data.al.length > 0) {
          //   user_company.province = this.data.al[0] || "";
          //   user_company.city = this.data.al[1] || "";
          //   user_company.area = this.data.al[2] || "";
          // }
          // if (this.data.parent_id) {
          //   user_company.parent_id = this.data.parent_id;
          // }


          // if (this.data.id) {
          //   // delete data.create_time;
          //   user_company.id = this.data.id;
          //   this.updateCompany({
          //     user: { id: this.data.user_id, tel: this.data.tel },
          //     user_company: user_company
          //   }).then(res => {
          //     this.loading = false;
          //     if(res){
          //       this.$Message.success("保存成功");
          //     }else{
          //       this.$Message.error("保存失败,名称已存在")
          //     }
          //   });
          // } else {
          //   let user = {
          //     name: this.data.company_name,
          //     is_company: 1
          //   };
          //   if (!this.data.type) {
          //     (user.tel = this.data.tel), (user.password = "123456");
          //   }
          //   this.insertCompany({ user: user, user_company: user_company }).then(
          //     res => {
          //       if (res.status) {
          //         this.data.id = res.company_id;
          //         this.data.user_id = res.user_id;
          //         this.data.agent_id = res.agent_id;
          //         this.loading = false;
          //       } else {
          //         this.loading = false;
          //         this.$Message.error(res.log);
          //       }
          //     }
          //   );
          // }
        // }
      // });
    },
    ...mapActions(['getAgentList','infoCompany','updateCompany','insertCompany','CompanyUserName']),
  },
  computed: mapGetters({
    user: "agent"
  }),
  watch:{

  }
};
</script>
<style lang='less'>

</style>
